import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postUpdateMessanger = (params) => {
    return axios.put(`${backendHost}/api/admin/messanger`, params);
};

export {
    postUpdateMessanger
}